module.exports = __webpack_public_path__ + "img/ji9.40b5fdf6.png";